export default __webpack_public_path__ + "static/media/p13.cee97a84.jpg";